import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { Home, HelpCircle, Key, BookOpen, Target } from 'lucide-react';
import './Sidebar.css';

const Sidebar = () => {
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <div className="sidebar">
      <ul className="sidebarList">

        {/* Dashboard */}
        <li className={`sidebarItem ${isActive('/') ? 'active' : ''}`} id={isActive('/') ? 'active' : ''}>
          <div className="backlink_route">
            <Link to="/" className="links">
              <div className="left_side_route_name">
                <div className="menu-item-content">
                  <div className="left-content">
                    <span className="icon-wrapper">
                      <Home size={18} />
                    </span>
                    <span className="titleSidebar">Dashboard</span>
                  </div>
                </div>
              </div>
            </Link>
          </div>
        </li>

        {/* Prompt Library */}
        <li className={`sidebarItem ${isActive('/prompt-library') ? 'active' : ''}`} id={isActive('/prompt-library') ? 'active' : ''}>
          <div className="backlink_route">
            <Link to="/prompt-library" className="links">
              <div className="left_side_route_name">
                <div className="menu-item-content">
                  <div className="left-content">
                    <span className="icon-wrapper">
                      <BookOpen size={18} />
                    </span>
                    <span className="titleSidebar">Prompt Library</span>
                  </div>
                </div>
              </div>
            </Link>
          </div>
        </li>

        {/* Angles & CTAs */}
        <li className={`sidebarItem ${isActive('/angles') ? 'active' : ''}`} id={isActive('/angles') ? 'active' : ''}>
          <div className="backlink_route">
            <Link to="/angles" className="links">
              <div className="left_side_route_name">
                <div className="menu-item-content">
                  <div className="left-content">
                    <span className="icon-wrapper">
                      <Target size={18} />
                    </span>
                    <span className="titleSidebar">Angles & CTAs</span>
                  </div>
                </div>
              </div>
            </Link>
          </div>
        </li>

        {/* Divider */}
        <li className="divider">
          <span>Settings & Support</span>
        </li>

        {/* API Settings */}
        <li className={`sidebarItem ${isActive('/api-settings') ? 'active' : ''}`} id={isActive('/api-settings') ? 'active' : ''}>
          <div className="backlink_route">
            <Link to="/api-settings" className="links">
              <div className="left_side_route_name">
                <div className="menu-item-content">
                  <div className="left-content">
                    <span className="icon-wrapper">
                      <Key size={18} />
                    </span>
                    <span className="titleSidebar">API Settings</span>
                  </div>
                </div>
              </div>
            </Link>
          </div>
        </li>

        {/* Help & Support */}
        <li className="sidebarItem">
          <div className="backlink_route">
            <a
              href="https://anthonyhayes.ladesk.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="links"
            >
              <div className="left_side_route_name">
                <div>
                  <span className="icon-wrapper">
                    <HelpCircle size={18} style={{ marginRight: '10px' }} />
                  </span>
                  <span className="titleSidebar">Help & Support</span>
                </div>
              </div>
            </a>
          </div>
        </li>

      </ul>
    </div>
  );
};

export default Sidebar;